import { render, staticRenderFns } from "./Identities.vue?vue&type=template&id=6cc995b9&scoped=true&"
import script from "./Identities.vue?vue&type=script&lang=js&"
export * from "./Identities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc995b9",
  null
  
)

export default component.exports